module.exports = __webpack_public_path__ + "img/pro_example.d0bdce46.png";